import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import {
    getTime2,
    hideScanner,
    isExternalCode,
    isWorkshopCode,
    showScanner,
} from "../../common/helpers";
import { Button, Modal, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Link, useLocation, useParams } from "react-router-dom";
import "./operator-scan.css";
import {
    drawEnvelopeTicket,
    // drawParentTicket,
    getTicketCanvas,
} from "../../common/card";
import { connectToPrinter, preparePrinter } from "../../common/printer";
import { Root } from "protobufjs";
import printdata from "../../printdata.json";
import History from "../history";

/**
 * flutter handler menggunakan window.flutter_inappwebview
 * Message Channel menggunakan variable window.port
 */

let headers;
const CustomAlert = withReactContent(Swal);
const Toast = CustomAlert.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});
var lastScannedTicket;
var timerClearLastScannedTicket;
var debugMode = false;
const root = Root.fromJSON(printdata);

/**
 * Request histories scan user
 * @returns []
 */
const getScanLogs = async (eventId, exclusive = "", batchId = "") => {
    headers = {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("operator_token"),
    };
    let result = [];
    try {
        let params = {
            church_event_id: eventId,
        };
        if (exclusive) {
            params.exclusive = exclusive;
        }
        if (batchId) {
            params.batch_id = batchId;
        }
        let req = await axios({
            method: "GET",
            url: `${process.env.REACT_APP_API2_URL}/me/scan/histories`,
            params,
            headers,
        });
        // isi ke variable hanya jika ada isinya saja
        if (req.data && req.data.results) {
            result = req.data.results;
        }
        if (req.data.showDebug) {
            debugMode = true;
        }
    } catch (exc) {
        console.error("Error loading scan histories");
        console.error(exc);
    }
    return result;
};

const getMSJBatchId = (code) => {
    return code.replace("MSJ-", "");
};

function OperatorScan() {
    const [event, setEvent] = useState({});
    const [data, setData] = useState(null);
    const [isScan, setIsScan] = useState(false);
    const [ticket, setTicket] = useState(0);
    const [alertShowModal, setAlertShowModal] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [scanLogs, setScanLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const params = useParams();
    const { search } = useLocation();
    const query = React.useMemo(() => new URLSearchParams(search), [search]);
    const isRereg = query.get("rereg") === "1" ? true : false;
    const exclusive = query.get("exclusive") || "";
    const isExternalEvent = params.code && params.code.startsWith("MSJ-");
    if (query.get("debug") === "1") {
        debugMode = true;
    }
    const canvasRef = useRef(null);
    const [printers, setPrinters] = useState([]);
    const [deviceId, setDeviceId] = useState("");

    const ConnectPrinter = () => {
        if (printers.length > 0) {
            return (
                <select
                    className="form-control"
                    value={deviceId}
                    onChange={(e) => {
                        if (e.target.value !== "") {
                            setDeviceId(e.target.value);
                            connectToPrinter(e.target.value);
                        }
                    }}
                >
                    <option value="">--Select Printer--</option>
                    {printers.map((printer, index) => (
                        <option key={index} value={printer.address}>
                            {printer.name} - {printer.rsii} ({printer.address})
                        </option>
                    ))}
                </select>
            );
        } else {
            return <></>;
        }
    };

    const renderHistories = useCallback(() => {
        return (
            <div className="container">
                <div className="mb-1">
                    <b>History Scan</b>
                </div>
                <div className="history-wrapper">
                    {scanLogs &&
                        scanLogs.map((log, i) => {
                            return (
                                <History key={`history-${i}`} log={log} i={i} />
                            );
                        })}
                </div>
            </div>
        );
    }, [scanLogs]);

    const renderExtras = (extras) => {
        if (!extras) {
            return <></>;
        }
        extras = JSON.parse(extras);
        const sanitize = (val) => String(val).replace(/(<([^>]+)>)/gi, "");
        const isSensitiveKey = (k) => {
            const key = String(k).toLowerCase();
            return (
                key.includes("email") ||
                key.includes("email_address") ||
                key.includes("cell_phone") ||
                key.includes("phone") ||
                key.includes("phone_number")
            );
        };
        const maskEmail = (email) => {
            const e = sanitize(email);
            const [local, domain] = e.split("@");
            if (!domain) return "***";
            const visible = (local || "").slice(0, 2);
            return `${visible}***@${domain}`;
        };
        const maskPhone = (phone) => {
            const p = sanitize(phone).replace(/\s+/g, "");
            const last4 = p.slice(-4);
            return `****${last4}`;
        };
        const maskSensitive = (k, v) => {
            if (v === undefined || v === null) return "";
            const key = String(k).toLowerCase();
            if (key.includes("email")) return maskEmail(v);
            if (key.includes("cell_phone") || key.includes("phone"))
                return maskPhone(v);
            return sanitize(v);
        };
        let s = "";
        for (let o in extras) {
            if (s !== "") {
                s += ", ";
            }
            const key = sanitize(o);
            const val = extras[o];
            // skip field address
            if (
                String(o).toLowerCase().includes("address") ||
                String(o).toLowerCase().includes("birth_date") ||
                String(o).toLowerCase().includes("date_of_birth")
            ) {
                continue;
            }
            let valStr = "";
            if (Array.isArray(val)) {
                valStr = val
                    .map((item) => {
                        if (item && typeof item === "object") {
                            return Object.entries(item)
                                .map(
                                    ([k, v]) =>
                                        `${sanitize(k)}=${
                                            isSensitiveKey(k)
                                                ? maskSensitive(k, v)
                                                : sanitize(v)
                                        }`
                                )
                                .join(", ");
                        }
                        return isSensitiveKey(key)
                            ? maskSensitive(key, item)
                            : sanitize(item);
                    })
                    .join("; ");
            } else if (val && typeof val === "object") {
                valStr = Object.entries(val)
                    .map(
                        ([k, v]) =>
                            `${sanitize(k)}=${
                                isSensitiveKey(k)
                                    ? maskSensitive(k, v)
                                    : sanitize(v)
                            }`
                    )
                    .join(", ");
            } else {
                valStr = isSensitiveKey(key)
                    ? maskSensitive(key, val)
                    : sanitize(val);
            }
            s += `${key}: <b>${valStr}</b>`;
        }
        return (
            <div style={{ marginLeft: "20px", marginRight: "20px" }}>
                Catatan:
                <br />
                <span dangerouslySetInnerHTML={{ __html: s }}></span>
            </div>
        );
    };

    const renderPaidStatus = (paidStatus) => {
        if (paidStatus === "PAID") {
            return <span className="badge badge-success">{paidStatus}</span>;
        } else {
            return <span className="badge badge-secondary">{paidStatus}</span>;
        }
    };

    const renderActions = () => {
        return (
            <div className="container text-right mt-4">
                <Link
                    to={{
                        pathname: "/operator/events",
                        state: {
                            lastEventCode: params.code,
                        },
                    }}
                    className="btn btn-outline-danger"
                    replace={true}
                >
                    Back
                </Link>
            </div>
        );
    };

    const handleScan = useCallback(
        (scanValue) => {
            if (!isScan && scanValue && scanValue !== lastScannedTicket) {
                setIsScan(true);
                setData(null);
                //* Temporary store ticket code to prevent double scan
                if (!debugMode) {
                    lastScannedTicket = scanValue;
                }
                // kalau pernah ada, clear dulu yang lama
                if (timerClearLastScannedTicket) {
                    clearTimeout(timerClearLastScannedTicket);
                }
                timerClearLastScannedTicket = setTimeout(() => {
                    lastScannedTicket = null;
                }, 20000);
                // khusus untuk yang menggunakan db payment
                // tiket workshop: payload flat bisa datang dari respon sukses
                // maupun error, jadi diproses lewat satu fungsi
                const handleWorkshopResponse = (body) => {
                    const workshop = body && (body.data || body.results);
                    // matikan overlay dulu sebelum toast muncul
                    lastScannedTicket = null;
                    setIsScan(false);
                    if (!workshop) {
                        Toast.fire({
                            icon: "error",
                            title:
                                (body && body.message) ||
                                "Gagal memproses tiket split conference",
                        });
                        return;
                    }
                    // tampilkan data hanya bila tiket belum dipakai
                    if (workshop.scanned_at) {
                        const scannedDate = new Date(workshop.scanned_at);
                        const scannedFormatted = scannedDate.toLocaleString(
                            undefined,
                            {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                            }
                        );
                        Toast.fire({
                            icon: "warning",
                            title: `Tiket sudah dipakai! (${scannedFormatted})`,
                        });
                        return;
                    }
                    setData({
                        ...workshop,
                        code: scanValue,
                        isWorkshop: true,
                    });
                    setTicket(1);
                };
                if (isExternalEvent || isExternalCode(scanValue)) {
                    console.log(!!window.port && !!deviceId);
                    axios
                        .get(
                            `${process.env.REACT_APP_API2_URL}/me/booking/${scanValue}/check`,
                            {
                                headers: headers,
                                params: {
                                    exclusive: exclusive,
                                    msj: isExternalEvent ? "1" : "0",
                                    return_data:
                                        !!window.port && !!deviceId
                                            ? "true"
                                            : "false", // kalau printer support, tetap minta kembalikan data
                                },
                            }
                        )
                        .then((res) => {
                            // tiket workshop punya bentuk data flat tersendiri
                            if (isWorkshopCode(scanValue)) {
                                handleWorkshopResponse(res.data);
                                return;
                            }
                            const booking = res.data.results;
                            setData(booking);
                            setTicket(booking.quantity);
                        })
                        .catch((err) => {
                            // tiket workshop: data bisa dikirim lewat respon error
                            if (isWorkshopCode(scanValue)) {
                                handleWorkshopResponse(
                                    err.response && err.response.data
                                );
                                return;
                            }
                            if (err.response) {
                                const data = err.response.data;
                                if (!!window.port && !!deviceId) {
                                    const booking = data.results;
                                    let message = data.message;
                                    if (booking.extras) {
                                        try {
                                            let extras = JSON.parse(
                                                booking.extras
                                            );
                                            if (extras["Participant ID"]) {
                                                message +=
                                                    " - Participant ID: " +
                                                    extras["Participant ID"];
                                            }
                                        } catch (exc) {
                                            console.error(exc);
                                        }
                                    }
                                    Swal.fire({
                                        icon: "error",
                                        title: "Error",
                                        text: message,
                                        showCancelButton: true,
                                        confirmButtonText: "Reprint",
                                        cancelButtonText: "Close",
                                        reverseButtons: true,
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            triggerPrint(booking).then(() => {
                                                lastScannedTicket = null; // dikosongkan lagi bila error, supaya bisa scan ulang
                                                setIsScan(false);
                                            });
                                        } else {
                                            lastScannedTicket = null; // dikosongkan lagi bila error, supaya bisa scan ulang
                                            setIsScan(false);
                                        }
                                    });
                                } else {
                                    const booking = data.results;
                                    let message = data.message;
                                    if (booking && booking.extras) {
                                        try {
                                            let extras = JSON.parse(
                                                booking.extras
                                            );
                                            if (extras["Participant ID"]) {
                                                message +=
                                                    " - Participant ID: " +
                                                    extras["Participant ID"];
                                            }
                                        } catch (exc) {
                                            console.error(exc);
                                        }
                                    }

                                    Toast.fire({
                                        icon: "error",
                                        title: message,
                                    }).finally(() => {
                                        lastScannedTicket = null; // dikosongkan lagi bila error, supaya bisa scan ulang
                                        setIsScan(false);
                                    });
                                }
                            }
                        });
                } else {
                    axios({
                        method: "GET",
                        url:
                            process.env.REACT_APP_API_URL +
                            "operator/check?booking_code=" +
                            scanValue,
                        headers,
                    })
                        .then((res) => {
                            if (res.data.success) {
                                console.log(event);
                                // setData(res.data.data);
                                // setTicket(res.data.data.quantity);
                                try {
                                    const resultEventID =
                                        res.data.data.sub_event.event_id;
                                    const subIds = params.id
                                        .split(",")
                                        .map((id) => +id);
                                    const isSameSubId = subIds.includes(
                                        +res.data.data.sub_event.id
                                    );
                                    const selectedExclusive = exclusive; // use exclusive only from URL
                                    const bypassExclusiveList = [
                                        "christmascelebration1",
                                        "christmascelebration2",
                                        "christmascelebration3",
                                        "christmascelebration4",
                                        "christmascelebration5",
                                    ];
                                    const bypassClientValidation =
                                        !!selectedExclusive &&
                                        bypassExclusiveList.includes(
                                            selectedExclusive
                                                .toString()
                                                .toLowerCase()
                                        );
                                    const bypassEventIds = [
                                        "12330", // christmascelebration1
                                        "12331", // christmascelebration2
                                        "12332", // christmascelebration3
                                        "12333", // christmascelebration4
                                    ];

                                    if (bypassClientValidation) {
                                        if (
                                            bypassEventIds.includes(
                                                String(resultEventID)
                                            )
                                        ) {
                                            setData(res.data.data);
                                            setTicket(res.data.data.quantity);
                                        } else {
                                            Toast.fire({
                                                icon: "warning",
                                                title: "Tidak sesuai jadwal / ruangan yang dipilih!",
                                            });
                                        }
                                    } else {
                                        if (
                                            event &&
                                            !!event.event_id &&
                                            event.event_id !== resultEventID
                                        ) {
                                            Toast.fire({
                                                icon: "warning",
                                                title: "Tidak sesuai jadwal / ruangan yang dipilih!",
                                            });
                                        } else if (
                                            !event.event_id &&
                                            !!params.id &&
                                            !isSameSubId
                                        ) {
                                            Toast.fire({
                                                icon: "warning",
                                                title: "Tidak sesuai jadwal / ruangan yang dipilih!",
                                            });
                                        } else {
                                            setData(res.data.data);
                                            setTicket(res.data.data.quantity);
                                        }
                                    }
                                } catch (exc) {
                                    // kalau error, biarkan set data langsung saja, karena lebih fatal jika gagal scan
                                    setData(res.data.data);
                                    setTicket(res.data.data.quantity);
                                } finally {
                                    setIsScan(false);
                                }
                            } else {
                                Toast.fire({
                                    icon: "warning",
                                    title: "Kode Salah, Silahkan Scan Ulang!",
                                });
                                setIsScan(false);
                            }
                        })
                        .catch((err) => {
                            lastScannedTicket = null; // dikosongkan lagi bila error, supaya bisa scan ulang
                            if (err.response) {
                                if (!!window.port && !!deviceId) {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Error",
                                        text: `${err.response.data.message}`,
                                        showCancelButton: true,
                                        confirmButtonText: "Reprint",
                                        cancelButtonText: "Close",
                                        reverseButtons: true,
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            triggerPrint(
                                                err.response.data.data
                                            ).then(() => {
                                                lastScannedTicket = null; // dikosongkan lagi bila error, supaya bisa scan ulang
                                                setIsScan(false);
                                            });
                                        } else {
                                            lastScannedTicket = null; // dikosongkan lagi bila error, supaya bisa scan ulang
                                            setIsScan(false);
                                        }
                                    });
                                } else {
                                    Toast.fire({
                                        icon: "error",
                                        title: `${err.response.data.message}`,
                                    });
                                }
                            }
                            setIsScan(false);
                        });
                }
            }
        },
        [exclusive, isExternalEvent, deviceId, params.id, event, isScan]
    );

    const messageHandler = useCallback(
        (ev) => {
            const message = ev.data;
            if (message.startsWith("SCAN_VALUE:")) {
                const scanValue = message.replace("SCAN_VALUE:", "");
                handleScan(scanValue);
            }
            if (message.startsWith("PRINTERS:")) {
                const printerList = message.replace("PRINTERS:", "");
                // load("/printdata.proto").then((root) => {
                const AvailablePrinters = root.lookupType("AvailablePrinters");
                const printerListArray = printerList
                    .split(",")
                    .map((num) => parseInt(num));
                const printerListBuffer = new Uint8Array(printerListArray);
                const printers = AvailablePrinters.decode(printerListBuffer);
                const uniquePrinters = printers.printers.filter(
                    (printer, index, self) =>
                        index ===
                        self.findIndex((p) => p.address === printer.address)
                );
                setPrinters(uniquePrinters);
                // });
            }
        },
        [handleScan]
    );

    const renderTicketButton = (ticketData) => {
        return (
            <div style={ticketConfirmStyle}>
                {Array.from(Array(ticketData.quantity), (e, i) => {
                    return (
                        <input
                            key={i}
                            type="button"
                            value={i + 1}
                            className={
                                "btn btn-ticket-qty " +
                                (ticket === i + 1 ? "" : "lowlight") +
                                " " +
                                ((i + 1) % 3 === 0
                                    ? "btn-warning"
                                    : (i + 1) % 2 === 0
                                    ? "btn-primary"
                                    : "btn-danger")
                            }
                            style={ticketButtonStyle}
                            onClick={(e) => setTicket(i + 1)}
                        />
                    );
                })}
            </div>
        );
    };

    const renderFooter = (event) => {
        return (
            <div className="fixed-bottom" style={footerScannerStyle}>
                <p style={{ marginBottom: 0, fontWeight: "bold" }}>
                    {event.main_event.name} - {event.name}
                </p>
                <p style={{ marginBottom: 0 }}>{event.room.name}</p>
            </div>
        );
    };

    useEffect(() => {
        let intervalMessageChannel = setInterval(() => {
            if (window.port) {
                // clear interval agar tidak perlu cek ulang
                clearInterval(intervalMessageChannel);
                showScanner();
                // setup listener
                window.port.onmessage = messageHandler;
                preparePrinter();
                window.port.postMessage("listPrinters");
                // const btAddress = "66:32:96:57:EE:83";
                // connectToPrinter(btAddress);
            }
        }, 500);
        headers = {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.getItem("operator_token"),
        };
        if (!isRereg && !isExternalEvent) {
            // ambil detail event bila tipe bukan rereg
            axios({
                method: "GET",
                url: `${process.env.REACT_APP_API_URL}operator/eventDetails?event_code=${params.code}&sub_event_id=${params.id}`,
                headers,
            })
                .then((res) => {
                    if (res.data.success) {
                        setEvent(res.data.data);
                        // ambil history event
                        getScanLogs(
                            params.id,
                            exclusive,
                            getMSJBatchId(params.code)
                        ).then((logs) => setScanLogs(logs));
                    } else {
                        setAlertShowModal(true);
                        setAlertMessage(
                            "Tidak ada informasi Event yang sedang berlangsung"
                        );
                    }
                })
                .catch((res) => {
                    setAlertShowModal(true);
                    setAlertMessage("Tidak ada Event yang sedang berlangsung");
                });
        } else {
            getScanLogs(params.id, exclusive, getMSJBatchId(params.code)).then(
                (logs) => setScanLogs(logs)
            );
        }
    }, [params, isRereg, exclusive, isExternalEvent]);

    const onSubmit = useCallback(() => {
        if (!isSubmitting) {
            setIsSubmitting(true);
            const payload = {
                booking_code: data.code,
                quantity: ticket,
            };
            // isi comment dengan operator_church_id hanya bila ada
            if (localStorage.getItem("operator_church_id")) {
                payload.comment = localStorage.getItem("operator_church_id");
            }
            if (
                (isExternalEvent || isExternalCode(data.code)) &&
                !data.code.includes("-EKCF-")
            ) {
                axios({
                    headers,
                    method: "POST",
                    url:
                        process.env.REACT_APP_API2_URL + "/me/booking/checkout",
                    params: {
                        exclusive: exclusive,
                        msj: isExternalEvent ? "1" : "0",
                    },
                    data: payload,
                })
                    .then((res) => {
                        // print jika support (tiket workshop tidak dicetak)
                        if (window.port && deviceId && !data.isWorkshop) {
                            triggerPrint(data);
                        } else {
                            setData(null);
                        }
                        Toast.fire({
                            icon: "success",
                            title: "Proses Checkout Berhasil",
                        });
                        // bila berhasil, refresh log scan
                        getScanLogs(
                            params.id,
                            exclusive,
                            getMSJBatchId(params.code)
                        ).then((logs) => setScanLogs(logs));
                    })
                    .catch((err) => {
                        Toast.fire({
                            icon: "error",
                            title: `${err.response.data.message}`,
                        });
                    })
                    .finally(() => {
                        setIsSubmitting(false);
                        setIsScan(false);
                    });
            } else {
                axios({
                    headers,
                    method: "POST",
                    url: process.env.REACT_APP_API_URL + "operator/checkout",
                    data: payload,
                })
                    .then((res) => {
                        // print jika support
                        if (window.port && deviceId) {
                            triggerPrint(data);
                        } else {
                            setData(null);
                        }
                        if (!res.data.success) {
                            Toast.fire({
                                icon: "warning",
                                title: "Terjadi kesalahan saat checkout",
                            });
                        } else {
                            Toast.fire({
                                icon: "success",
                                title: "Proses Checkout Berhasil",
                            });
                            // bila berhasil, refresh log scan
                            getScanLogs(
                                params.id,
                                exclusive,
                                getMSJBatchId(params.code)
                            ).then((logs) => setScanLogs(logs));
                        }
                    })
                    .catch((err) => {
                        Toast.fire({
                            icon: "error",
                            title: `${err.response.data.message}`,
                        });
                    })
                    .finally(() => {
                        setIsSubmitting(false);
                        setIsScan(false);
                    });
            }
        }
    }, [isSubmitting, ticket, data, params]);

    // handler memunculkan dan menghilangkan scanner
    useEffect(() => {
        if (isScan) {
            hideScanner();
        } else {
            // showScanner return boolean to flag request processed or not
            if (showScanner()) {
                // setup listener
                window.port.onmessage = messageHandler;
            }
        }
    }, [isScan, messageHandler]);

    // handler bila ada perubahan di variable data
    useEffect(() => {
        if (data != null) {
            /// auto submit sementara di non-aktifkan
            // // bila ticket yang di scan hanya 1 saja, langsung set checkout
            // const qty = data.quantity;
            // if (qty === 1) {
            //     onSubmit();
            //
        }
    }, [data, onSubmit]);

    const alertHandleClose = () => {
        setAlertShowModal(false);
    };

    const triggerPrint = async (data) => {
        setIsLoading(true);
        console.log("triggerPrint");
        const { canvas, ctx } = getTicketCanvas();
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        console.log(data);
        await drawEnvelopeTicket(ctx, data);

        const img = canvas
            .toDataURL("image/png")
            .replace(/^data:image\/png;base64,/, "");

        if (canvasRef && canvasRef.current) {
            const ctx2 = canvasRef.current.getContext("2d");
            ctx2.drawImage(canvas, 0, 0);
        }
        // console.log("load printdata");
        // const CustomPrintData = root.lookupType("CustomPrintData");
        // const PrintRawData = root.lookupType("PrintRawData");
        // let printRawData = PrintRawData.create({
        //     type: PrintRawData.Type.IMAGE,
        //     content: img,
        //     x: 0,
        //     y: 0,
        //     size: 500,
        // });
        // const printData = CustomPrintData.create({
        //     lines: [printRawData],
        // });
        // var buffer = CustomPrintData.encode(printData).finish();
        // const message = buffer.join(",");
        if (window.port && deviceId) {
            // console.log("print:" + message);
            // window.port.postMessage("print:" + message);
            window.port.postMessage("printImage:" + img);

            const timeout = debugMode ? 5000 : 3000;
            // Tambahkan timeout untuk loading
            setTimeout(() => {
                setIsLoading(false);
                setIsSubmitting(false);
                setIsScan(false);
                setData(null);
            }, timeout);
        } else {
            setIsLoading(false);
            if (!debugMode || !!window.port) {
                setIsSubmitting(false);
                setIsScan(false);
                setData(null);
            }
        }
    };

    if (isRereg || isExternalEvent || event.name) {
        if (data !== null && data.isWorkshop) {
            // tampilan khusus tiket workshop (bentuk data flat tersendiri)
            const accent = `#${data.ticket_color_hex || "0040BC"}`;
            const initials =
                (data.participant_name || "")
                    .trim()
                    .split(/\s+/)
                    .slice(0, 2)
                    .map((w) => w[0])
                    .join("")
                    .toUpperCase() || "?";
            return (
                <div style={workshopPageStyle}>
                    <div style={workshopCardStyle}>
                        <div
                            style={{
                                ...workshopAccentBarStyle,
                                backgroundColor: accent,
                            }}
                        ></div>
                        <div style={workshopBodyStyle}>
                            <div
                                style={{
                                    ...workshopTagStyle,
                                    color: accent,
                                    borderColor: accent,
                                }}
                            >
                                Tiket Split Conference
                            </div>
                            <div style={workshopTitleStyle}>
                                {data.workshop_name}
                            </div>
                            <div style={workshopParticipantStyle}>
                                <div
                                    style={{
                                        ...workshopAvatarStyle,
                                        backgroundColor: accent,
                                    }}
                                >
                                    {initials}
                                </div>
                                <div style={{ minWidth: 0 }}>
                                    <div style={workshopLabelStyle}>Peserta</div>
                                    <div style={workshopNameStyle}>
                                        {data.participant_name}
                                    </div>
                                </div>
                            </div>
                            <div style={workshopStatusStyle}>
                                <span style={{ fontSize: "1.1rem" }}>✓</span>
                                Tiket valid, belum dipakai
                            </div>
                        </div>
                    </div>
                    <div style={workshopFooterStyle}>
                        <input
                            type="button"
                            className="btn btn-success"
                            style={workshopSubmitStyle}
                            value={isSubmitting ? "Memproses..." : "Submit"}
                            onClick={onSubmit}
                            disabled={isSubmitting ? true : false}
                        />
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            style={workshopBackStyle}
                            onClick={() => {
                                lastScannedTicket = null;
                                setIsScan(false);
                                setData(null);
                            }}
                        >
                            Batal
                        </button>
                    </div>
                </div>
            );
        }
        if (data !== null) {
            const colorHex =
                data.ticket_color_hex || data.sub_event.ticket_color_hex;
            return (
                <>
                    {isLoading && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 9999,
                            }}
                        >
                            <Spinner animation="border" variant="light" />
                        </div>
                    )}
                    <div style={headerStyle}>
                        <div
                            className="ticket-block"
                            style={
                                [
                                    14945, 14943, 14944, 15110, 15111, 15109,
                                ].includes(data.sub_event.id)
                                    ? {
                                          background: `linear-gradient(#${colorHex}, #${colorHex}) left / 65% 100% no-repeat, linear-gradient(#1a6662, #1a6662) right / 35% 100% no-repeat`,
                                      }
                                    : [14947, 14948, 14946].includes(
                                          data.sub_event.id
                                      )
                                    ? {
                                          background: `linear-gradient(#${colorHex}, #${colorHex}) left / 65% 100% no-repeat, linear-gradient(#637a39, #637a39) right / 35% 100% no-repeat`,
                                      }
                                    : [14949, 14950, 14951].includes(
                                          data.sub_event.id
                                      )
                                    ? {
                                          background: `linear-gradient(#${colorHex}, #${colorHex}) left / 65% 100% no-repeat, linear-gradient(#a86925, #a86925) right / 35% 100% no-repeat`,
                                      }
                                    : [14952, 14953].includes(data.sub_event.id)
                                    ? {
                                          background: `linear-gradient(#${colorHex}, #${colorHex}) left / 65% 100% no-repeat, linear-gradient(#c23d92, #c23d92) right / 35% 100% no-repeat`,
                                      }
                                    : {
                                          backgroundColor: `#${colorHex}`,
                                      }
                            }
                        ></div>
                        <div
                            style={{
                                fontSize: "1.5eem",
                                textAlign: "center",
                                fontWeight: "bold",
                                color: "white",
                                textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
                                padding: "0.2rem 0",
                                backgroundColor:
                                    data.sub_event.name.toUpperCase() === "SCC"
                                        ? "#F0BF13"
                                        : "#0040BC",
                                borderRadius: "8px",
                                margin: "0.5rem 0",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                            }}
                        >
                            {data.sub_event.name.toUpperCase()}
                        </div>
                        {!isRereg && getTime2(data.sub_event.start_date)}
                        {(() => {
                            const roomName = data.sub_event.room.name || "";
                            const isOverflowRoom = roomName
                                .toString()
                                .toLowerCase()
                                .includes("overflow");
                            return (
                                <div
                                    style={
                                        isOverflowRoom
                                            ? {
                                                  backgroundColor: "#ffd54f",
                                                  color: "#000",
                                                  fontSize: "1.3rem",
                                                  fontWeight: "bold",
                                                  padding: "4px 8px",
                                                  borderRadius: "6px",
                                                  display: "inline-block",
                                                  marginTop: "4px",
                                              }
                                            : undefined
                                    }
                                >
                                    {isOverflowRoom
                                        ? "OVERFLOW"
                                        : data.sub_event.room.name}
                                </div>
                            );
                        })()}
                    </div>
                    {/* {!isRereg && (
                        <p style={bookingStyle}>{data.sub_event.room.name}</p>
                    )} */}
                    <div style={bookingStyle}>
                        {data.participant.name}, <b>{data.quantity}</b> Tiket{" "}
                        {renderPaidStatus(data.paid_status)}
                    </div>
                    {renderExtras(data.extras)}
                    <p style={confirmStyle}>Jumlah tiket yang akan diproses</p>
                    {renderTicketButton(data)}
                    {debugMode && !window.port && (
                        <div>
                            <canvas
                                ref={canvasRef}
                                width={640}
                                height={220}
                            ></canvas>
                            <button
                                className="btn btn-primary w-100 p-3"
                                onClick={() => triggerPrint(data)}
                                type="button"
                            >
                                Test Print
                            </button>
                        </div>
                    )}
                    {debugMode && window.port && (
                        <button
                            className="btn btn-primary w-100 p-3"
                            onClick={() => triggerPrint(data)}
                            type="button"
                        >
                            Test Print
                        </button>
                    )}
                    <div
                        className="d-flex gap-2"
                        style={{
                            position: "absolute",
                            bottom: "0",
                            width: "100%",
                            padding: "0 20px",
                        }}
                    >
                        <input
                            type="button"
                            className="btn btn-success flex-grow-1"
                            style={{
                                paddingTop: "20px",
                                paddingBottom: "20px",
                                textTransform: "uppercase",
                                fontSize: "1.3rem",
                            }}
                            value={isSubmitting ? "Submiting..." : "Submit"}
                            onClick={onSubmit}
                            disabled={isSubmitting ? true : false}
                        />
                        <button
                            type="button"
                            className="btn btn-outline-danger flex-grow-0"
                            style={{
                                paddingTop: "10px",
                                marginLeft: "0.5em",
                                paddingBottom: "10px",
                                textTransform: "uppercase",
                                fontSize: "1rem",
                                width: "25%",
                            }}
                            onClick={() => {
                                lastScannedTicket = null;
                                setIsScan(false);
                                setData(null);
                            }}
                        >
                            Back
                        </button>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    {isScan && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 9999,
                                gap: "1rem",
                            }}
                        >
                            <Spinner animation="border" variant="light" />
                            <span style={{ color: "#fff", fontSize: "1rem" }}>
                                Memproses...
                            </span>
                        </div>
                    )}
                    <div className="font-barlow-regular">preload font</div>
                    <div className="font-barlow-medium">preload font</div>
                    <div className="container-fluid no-padding">
                        {<ConnectPrinter />}
                        <p style={infoStyle}>Scan QR Code dengan Kamera Anda</p>
                    </div>
                    {debugMode && (
                        <div className="text-center">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() =>
                                    handleScan(
                                        "gscsc-EMGMSCONF-607dee7f-0b3c-4491-b9f6-9249ebe90581"
                                    )
                                }
                            >
                                Debug
                            </button>
                        </div>
                    )}
                    {renderHistories()}
                    {renderActions()}
                    {!isRereg && !isExternalEvent && renderFooter(event)}

                    {/* Alert Modal */}
                    <Modal show={alertShowModal} onHide={alertHandleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title style={modalAlertTitleStyle}>
                                Peringatan
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p style={modalAlertStyle}>{alertMessage}</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={alertHandleClose}>OK</Button>
                        </Modal.Footer>
                    </Modal>
                </>
            );
        }
    } else {
        return null;
    }
}

//Styles
const footerScannerStyle = {
    backgroundColor: "#1d2434",
    color: "#fff",
    textAlign: "center",
    padding: "7px",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
};

const ticketButtonStyle = {
    padding: "2px 8px",
    marginRight: "8px",
    flex: "1",
    fontSize: "1.5rem",
    paddingTop: "20px",
    paddingBottom: "20px",
};

const infoStyle = {
    marginTop: "30px",
    textAlign: "center",
};

const headerStyle = {
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "1em",
    marginBottom: "0px",
    fontWeight: "bold",
    fontSize: "1.2rem",
};

const bookingStyle = {
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "4px",
    fontSize: "1.0rem",
};

const confirmStyle = {
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "1em",
    fontSize: "1.0rem",
    marginBottom: "1em",
};

const ticketConfirmStyle = {
    marginLeft: "20px",
    marginRight: "20px",
    marginBottom: "40px",
    display: "flex",
};

const submitStyle = {
    width: "100%",
    position: "absolute",
    bottom: "0",
    paddingTop: "20px",
    paddingBottom: "20px",
    textTransform: "uppercase",
    fontSize: "1.3rem",
};

// Workshop ticket (mobile web) styles
const workshopPageStyle = {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "#f2f4f8",
    padding: "16px",
    paddingBottom: "100px",
};

const workshopCardStyle = {
    background: "#fff",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
    marginTop: "8px",
};

const workshopAccentBarStyle = {
    height: "8px",
    width: "100%",
};

const workshopBodyStyle = {
    padding: "24px 20px",
};

const workshopTagStyle = {
    display: "inline-block",
    fontSize: "0.72rem",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    border: "1.5px solid",
    borderRadius: "999px",
    padding: "4px 12px",
    marginBottom: "14px",
};

const workshopTitleStyle = {
    fontSize: "2rem",
    fontWeight: 800,
    lineHeight: 1.15,
    margin: "0 0 22px",
    color: "#1d2434",
    wordBreak: "break-word",
};

const workshopParticipantStyle = {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    paddingTop: "14px",
    borderTop: "1px solid #eef0f4",
};

const workshopAvatarStyle = {
    width: "52px",
    height: "52px",
    borderRadius: "50%",
    color: "#fff",
    fontWeight: 700,
    fontSize: "1.2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
};

const workshopLabelStyle = {
    fontSize: "0.75rem",
    color: "#8a93a6",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: "2px",
};

const workshopNameStyle = {
    fontSize: "1.25rem",
    fontWeight: 700,
    color: "#1d2434",
    wordBreak: "break-word",
};

const workshopStatusStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "18px",
    background: "#e7f7ee",
    color: "#1c8c54",
    fontWeight: 600,
    fontSize: "0.95rem",
    padding: "10px 14px",
    borderRadius: "10px",
};

const workshopFooterStyle = {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    display: "flex",
    gap: "10px",
    padding: "12px 16px",
    background: "#fff",
    boxShadow: "0 -2px 12px rgba(0,0,0,0.06)",
};

const workshopSubmitStyle = {
    flex: 1,
    padding: "16px",
    fontSize: "1.2rem",
    fontWeight: 700,
    textTransform: "uppercase",
    borderRadius: "12px",
};

const workshopBackStyle = {
    width: "28%",
    padding: "16px",
    fontSize: "1rem",
    fontWeight: 600,
    textTransform: "uppercase",
    borderRadius: "12px",
};

const modalAlertTitleStyle = {
    color: "#555",
    fontSize: "0.75rem",
    fontWeight: "bold",
};

const modalAlertStyle = {
    fontSize: "0.8rem",
};

export default OperatorScan;
